<router-outlet></router-outlet> <cds-loader></cds-loader> <cds-progress-loader></cds-progress-loader>
<cds-confirmation-dialog></cds-confirmation-dialog>
